import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { firestoreDb } from "../utils/firebase";

const db = firestoreDb;

export function useVersionCheck() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    const env = import.meta.env.VITE_SENTRY_ENV as string | undefined;

    // Only run in staging and production — skip local dev
    if (!env || env === "development") return;

    const currentVersion = import.meta.env.VITE_APP_VERSION as string;
    const configRef = doc(db, "consultation-web-config", env);

    const unsubscribe = onSnapshot(configRef, (snapshot) => {
      const data = snapshot.data();
      if (data?.version && data.version !== currentVersion) {
        setUpdateAvailable(true);
      }
    });

    return unsubscribe;
  }, []);

  return updateAvailable;
}
